// extracted by mini-css-extract-plugin
export default {"wrappedContainer":"profile_item_display-module___wrappedContainer___b0d93424","personFrom":"profile_item_display-module___personFrom___ce29b6a3"};